import { ReactNode } from 'react'
import { Spinner } from 'react-bootstrap'

import { IconButton, IconButtonProps } from './IconButton'

export type ButtonProps = {
  children: ReactNode | string
  icon?: ReactNode
  iconPosition?: 'left' | 'right'
  disabled?: boolean
  loading?: boolean
} & IconButtonProps

export function Button({
  children,
  icon,
  iconPosition = 'right',
  loading,
  disabled,
  ...props
}: ButtonProps) {
  return (
    <IconButton {...props} disabled={disabled || loading}>
      {iconPosition === 'left' && icon}
      <div>{children}</div>
      {loading && <Spinner animation="border" size="sm" />}
      {iconPosition === 'right' && icon}
    </IconButton>
  )
}
